import {actions, ActionType} from './actions';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../common/util/redux';
import {
  IViewerContent,
  IViewerDecryptInfo,
  IViewerEnd,
  IViewerEpisode,
  IViewerImage,
  IViewerState,
} from '../type';

export interface IStateViewer {
  episode?: IViewerEpisode;
  content?: IViewerContent;
  decryptInfo?: IViewerDecryptInfo;
  images: IViewerImage[];
  prevEpisode?: IViewerEpisode;
  nextEpisode?: IViewerEpisode;
  viewerEnd?: IViewerEnd;
  curEpisodeOffset?: number;
  viewerState: IViewerState;
  prevViewerState: IViewerState;
  isRunMode: boolean;
  isPlayBgm: boolean;
  autoScrollSpeed: number;
  isImageReady: boolean;
}

const INITIAL_STATE: IStateViewer = {
  images: [],
  viewerState: 'default',
  prevViewerState: 'default',
  isRunMode: false,
  isPlayBgm: false,
  autoScrollSpeed: 0,
  isImageReady: false,
};

export default createReducer<IStateViewer, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
    [ActionType.SetViewerState]: (state, action) => {
      const {viewerState} = action.payload;
      if (viewerState !== state.viewerState) {
        state.prevViewerState = state.viewerState;
        state.viewerState = viewerState;
      }
    },
    [ActionType.InitViewerState]: state => {
      state.viewerState = 'default';
      state.prevViewerState = 'default';
      state.isPlayBgm = false;
      state.autoScrollSpeed = 0;
    },
    [ActionType.SetResources]: (state, action) => {
      const {images, decryptInfo} = action.payload;
      state.images = images;
      state.decryptInfo = decryptInfo;
    },
    [ActionType.SetViewerData]: (state, action) => {
      const {prevEpisode, nextEpisode, viewerEnd, curEpisodeOffset} =
        action.payload;
      state.prevEpisode = prevEpisode;
      state.nextEpisode = nextEpisode;
      state.viewerEnd = viewerEnd;
      state.curEpisodeOffset = curEpisodeOffset;
    },
    [ActionType.SetImageUrl]: (state, action) => {
      const {index, url, episodeId} = action.payload;
      if (state.episode?.id === episodeId && state.images.length > index) {
        state.images[index].url = url;
        state.isImageReady = true;
      }
    },
    [ActionType.SetViewerContentAndEpisode]: (state, action) => {
      const {content, episode} = action.payload;
      state.content = content;
      state.episode = episode;
      state.decryptInfo = undefined;
      state.isImageReady = false;
      state.images = [];
    },
  }
);
